const AUTH_RESPONSE = 'AUTH_RESPONSE';

export default { AUTH_RESPONSE };
